// The cache is a "show first, refresh in the background" layer — when the
// page mounts we paint the cached numbers immediately so the SmartStack
// hero doesn't blank out for a network round-trip, then `useOverview`
// fetches fresh data and replaces them. If the model state changes (e.g.
// a new run completes) the new data overwrites the cache transparently.

const KEY = 'hrv4_overview_cache_v1';
const TTL_MS = 60 * 60 * 1000; // 1 hour

export function hasValidOverviewCache() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.timestamp !== 'number') return false;
    return Date.now() - parsed.timestamp < TTL_MS;
  } catch (_) {
    return false;
  }
}

export function loadStoredOverview() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.data ? parsed.data : null;
  } catch (_) {
    return null;
  }
}

export function storeOverview(data) {
  if (!data) return;
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ data, timestamp: Date.now() })
    );
  } catch (_) {
    // Quota errors / privacy mode — caching is best-effort.
  }
}

export function clearOverviewCache() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {}
}